import { useRoutes } from 'react-router';
import MainRoute from './setting/route';

export default function Routes() {
  return useRoutes([MainRoute]);
}
